import { webchatApi, AuthService } from "@rshbintech.dboul/http";
import type { Config } from "@rshbintech.ctp/webchat";

export const featureToggleKeys = [
  "chatEnable", // Доступность чата
  "chatFileSending", // Отправка файлов в чате
];

export const apiCallbacks: Config["api"] = {
  postUser: webchatApi.api.v2Auth,
  getChatInfo: webchatApi.api.v2ChatData,
  postChatInfo: webchatApi.api.v2ChatCreateData,
  getChatSettings: webchatApi.api.v2GetOmits,
  getMessages: webchatApi.api.v2GetMessages,
  postEvent: webchatApi.api.v2CreateEvent,
  postMessage: webchatApi.api.v2SendMessage,
  postMessageFile: webchatApi.api.v2SendMessageFile,
  getFile: webchatApi.api.v2GetFile,
};

export const sseConfig: Config["sse"] = {
  link: "api/chats/v2/external/updates/{{userId}}?token={{accessToken}}",
  getAccessTokenDboul: AuthService.getAccessToken,
};
